import authSvc from '@efex-services/auth/authSvc';
import { useApiCall } from '@efexteam/use-api-call';
import { selectProfileData } from '@pages/profile/store/selectors';
import { IMembers } from '@pages/profile/types';
import { deepSnakeToCamel } from '@utils/formater';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const useTeamMembers = () => {
  const userProfile = useSelector(selectProfileData);

  const { enterpriseId } = userProfile?.company || {};
  const {
    data,
    loading,
    invoke: getTeam,
  } = useApiCall(() =>
    authSvc
      .getTeam(enterpriseId || '')
      .then((x) => deepSnakeToCamel(x) as IMembers[])
  );

  useEffect(() => {
    if (enterpriseId && !data) {
      getTeam();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enterpriseId, data]);

  return { data, loading };
};

export default useTeamMembers;
